/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from "react";
import { useSelector, shallowEqual } from "react-redux";
import { toast } from "react-toastify";

import { useMutation } from "@apollo/client";
import { Switch } from "@material-ui/core";

import { SectionLoader } from "../SectionLoader";

import { MANAGE_STATUS } from "./mutation";

export const StatusPopper = props => {
  const { handlePopoverClose, currentUserUIProps } = props;

  const [
    manageStatus,
    {
      loading: manageStatusLoading,
      error: manageStatusError,
      data: manageStatusData,
    },
  ] = useMutation(MANAGE_STATUS);

  const { currentStateAuth } = useSelector(
    state => ({ currentStateAuth: state.auth }),
    shallowEqual,
  );

  const { user } = currentStateAuth;

  useEffect(() => {
    if (manageStatusError) {
      handlePopoverClose();
      toast.error(manageStatusError.toString(), {
        position: toast.POSITION.TOP_RIGHT,
      });
    }

    if (manageStatusData) {
      currentUserUIProps.setCurrentUser();
      toast.success(manageStatusData?.setOnlineStatus?.message, {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  }, [manageStatusData, manageStatusError]);

  const manageStatusFunc = status => {
    manageStatus({
      variables: {
        isOnline: status,
      },
    });
  };

  return (
    <>
      <SectionLoader loader={manageStatusLoading} />
      <div className={`${!user?.isOnline ? "darkActive" : ""} swich-label`}>
        <label className="lightLabel">Offline</label>
        <Switch
          checked={user?.isOnline}
          onChange={() => {
            if (user?.isOnline) manageStatusFunc(false);
            else manageStatusFunc(true);
          }}
          color="primary"
          name="checkedB"
          inputProps={{ "aria-label": "primary" }}
        />
        <label className="darkLabel">Online</label>
      </div>
    </>
  );
};
